// FORM shown as dots of the last 6 games everywhere (approved design).
export const FORM_DOTS = true;
document.documentElement.classList.add("form-dots");
